import React from 'react';
import { Box, BoxProps, withStyles } from '@material-ui/core';
import cn from 'classnames';

interface WrapperBoxProps extends BoxProps {
  isBlocked?: boolean;
  withTopBarNotification?: boolean;
}

export const WrapperBox = withStyles(({ breakpoints }) => ({
  root: {
    position: 'relative',
    transition: `padding-left .3s ease-in-out`,
    [breakpoints.up('md')]: {
      paddingLeft: 250,
    },
    '&.isBlocked': {
      paddingLeft: 0,
    },
    '&.withTopBarNotification': {
      paddingBottom: 190,
      [breakpoints.up('sm')]: {
        paddingBottom: 140,
      },
      [breakpoints.up('md')]: {
        paddingTop: 100,
        paddingBottom: 0,
      },
    },
  },
}))(({ isBlocked, withTopBarNotification, ...otherProps }: WrapperBoxProps) => (
  <Box {...otherProps} className={cn({ isBlocked, withTopBarNotification })} />
));

export const ContentBox = withStyles(({ spacing, breakpoints }) => ({
  root: {
    padding: spacing(2, 2, 0),
    [breakpoints.up('sm')]: {
      padding: spacing(4, 6),
    },
  },
}))(Box);
